import axios from 'axios'
import Qs from 'qs'
import vue from '../main'

export default {
  axios,
  Get (url, data = null, isReturn = false) {
    return new Promise((resolve) => {
      axios.get(url, { params: data }).then(res => {
        if (isReturn || res.flag) {
          resolve(res);
        }
      })
    });
  },
  Post (url, data = null, isReturn = false) {
    return new Promise((resolve) => {
      axios.post(url, data).then(res => {
        if (isReturn || res.flag) {
          resolve(res);
        }
      })
    });
  },
  Upload (url, data, isReturn = false) {
    return new Promise((resolve) => {
      axios({ url: url, method: 'post', data: data, headers: { 'Content-Type': 'multipart/form-data' } }).then(res => {
        if (isReturn || res.flag) {
          resolve(res);
        }
      })
    });
  }
}

axios.defaults.baseURL = process.env.NODE_ENV == "development" ? 'http://localhost:5000' : "http://" + window.location.host;


//返回状态判断(添加响应拦截器)
axios.interceptors.response.use(
  res => {
    //对响应数据做些事
    if (res.data.flag) {
      return res.data;
    } else {
      if (vue.$route.meta.type == "System") {
        vue.$tool.System.msg(res.data.err, "提示", 3);
      } else {
        vue.$tool.Phone.msg(res.data.err, 3);
      }
      return res.data;
    }
  },
  err => {
    if (vue.$route.meta.type == "System") {
      if (err.response.status == 401) {
        vue.$router.push({ name: "Login" });
      } else {
        vue.$tool.System.msg("错误：" + err.response.status, "提示", 3);
      }

    } else {
      vue.$tool.Phone.msg(err.response.status, 3);
    }
  }
);

// 添加请求拦截器
axios.interceptors.request.use(function (config) {
  if (!config.headers.Authorization) {
    var token = vue.$tool.ss.Get(vue.$config.LoginToken);
    if (token) {
      var data = JSON.parse(token);
      var Authorization = data.type + " " + data.token;
      config.headers.Authorization = Authorization;
    }
  }

  // 在发送请求之前做些什么
  if (config.method == "post") {

  }
  return config;
}, function (error) {
  // 对请求错误做些什么
  return Promise.reject(error);
});

